<template>
    <div>
        <div style="background-color: #fff;padding: 20px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/user/tp/list' }">图文列表</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/user/tp/list?col='+this.item_info.colname }" v-if="this.item_info.colname">{{this.item_info.colname}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ item_info.name ? item_info.name : '新建图文' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="display: flex;align-items: center;margin-top: 20px;">
                项目名:
                <el-input v-model="item_info.name" placeholder="项目名" style="width: 100px;margin-left: 10px;"
                    size="mini"></el-input>
            </div>
            <div style="margin-top: 20px;display: flex;">
                <el-image :src="imageUrl" :preview-src-list="[imageUrl]"
                    :style="{ height: `${item_info.make_item.resize.height / 2.5}px`, width: `${item_info.make_item.resize.width / 2.5}px` }"></el-image>
                <div style="margin-left: 20px;">
                    <el-upload action="https://video.kissxx.cn/qhy/tp/api_shibie" :data="item_info"
                        :headers="token"
                        :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                        :on-success="upload_ok" multiple :limit="1" :on-exceed="handleExceed"
                        :before-upload="handleBeforeUpload" :file-list="fileList">
                        <el-button size="small" type="primary">上传自动识别</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5mb</div>
                    </el-upload>
                    <div class="biaoqian" style="margin-top: 20px;">选择合集</div>
                    <el-select v-model="item_info.colname" filterable placeholder="请选择" size="small">
                        <el-option v-for="item in col_list" :key="item.id" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                    <div v-if="item_info.colname" style="font-size: 13px;margin-top: 10px;">
                        <div class="biaoqian" style="">设置合集封面</div>
                        <div style="margin-top: 0px;">
                            <el-radio-group v-model="cover_status" @input="col_cover">
                                <el-radio :label="1">开启</el-radio>
                                <el-radio :label="0">关闭</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="biaoqian">
                    尺寸设置
                </div>
                <div style="display: flex;align-items: center;">
                    宽：<el-input v-model="item_info.make_item.resize.width" placeholder="宽"
                        style="width: 80px;margin-right: 10px;" size="mini"></el-input>
                    高: <el-input v-model="item_info.make_item.resize.height" placeholder="高" style="width: 80px;"
                        size="mini"></el-input>
                </div>
                <div class="biaoqian">
                    文字设置
                </div>
                <div style="display: flex;align-items: center;flex-wrap: wrap;font-size: 14px;margin-bottom: 20px;"
                    v-for="(item, index) in item_info.make_item.text_list">
                    <div style="display: flex;width: 100%;">
                        文本：<el-input type="textarea" :rows="1" v-model="item.text" placeholder="文字内容"
                            style="margin-right: 10px;width: 85%;" size="small"></el-input>
                    </div>
                    <div style="margin-top: 10px;display: flex;align-items: center;">
                        竖向: <el-input v-model="item.text_y" placeholder="竖向位置" style="width: 80px;margin-right: 10px;"
                            size="mini"></el-input>
                        横向: <el-input v-model="item.text_x" placeholder="横向位置" style="width: 80px;margin-right: 10px;"
                            size="mini"></el-input>
                        字体大小: <el-input v-model="item.size" placeholder="大小" style="width: 80px;margin-right: 10px;"
                            size="mini"></el-input>

                        <!-- <el-input v-model="item.color" placeholder="颜色" style="width: 80px;margin-right: 10px;"
                            size="mini"></el-input> -->
                        居中: <el-input v-model="item.text_center" placeholder="居中" style="width: 80px;margin-right: 10px;"
                            size="mini"></el-input>
                        颜色:<el-color-picker v-model="item.color" size="small" style="margin-right: 20px;"></el-color-picker>
                        <el-button size="mini" round type="danger" @click="del_text(item, index)">删除</el-button>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <el-button size="mini" round type="primary" @click="add_text">+添加文本</el-button>
                    <el-button size="mini" round type="primary" @click="make_fc">生成图片</el-button>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            imageUrl: '',
            cover_status:0,
            item_info: {
                name: '',
                colid:'',
                make_item: {
                    page: '',
                    resize: {
                        width: 600,
                        height: 750,
                    },
                    text_list: []
                }
            },
            newitem: {
                'text': '文字',
                'text_y': 0,
                'text_x': 0,
                'size': 30,
                'color': '#ffffff',
                'text_center': 0,
            },
            fileList: [],
            col_list: [],
            token:''
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
        elSelectedOptionName() {
            console.log(1)
            const selectedOption = this.options.find(option => option.id === this.selectedOptionId);
            return selectedOption ? selectedOption.name : '';
        },
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        col_cover(e){
            console.log(e)
            if(this.imageUrl){
                this.$ajax.post('qhy/tp/col_fc', { cover: this.imageUrl,tp_item:this.item_info.id,colname:this.item_info.colname,set:e }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        this.$toast.show('设置成功')
                    }
                    
                })
            }else{
                
                this.cover_status=0
                this.$toast.show('请先制作图片')
            }
        },  
        // col_fc(e){
        //     console.log(e)
        //     if(e && this.col_list==[]){

        //     }
        // },
        del_text(item, index) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.item_info.make_item.text_list.splice(index, 1)
            }).catch(() => {
            });

        },
        handleBeforeUpload(file) {
            // 在 before-upload 事件中修改上传文件的配置
            file.headers = {};
            return true; // 返回 true 表示继续上传，返回 false 表示取消上传
        },
        upload_ok(res) {
            console.log(res)
            if (res.status == 200) {
                this.item_info = res.list
                this.item_info['make_item'] = JSON.parse(this.item_info['make_item'])
                this.imageUrl = this.item_info['image'];
            }
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        get_info(id) {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('qhy/tp/get_info', { id: id }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.item_info = res.data.list
                    this.item_info['make_item'] = JSON.parse(this.item_info['make_item'])
                    this.imageUrl = this.item_info['image'];
                    this.cover_status=res.data.col_status
                }
                loading.close();
            })
        },
        make_fc() {
            var data = this.item_info
            console.log(data)
            this.$ajax.post('qhy/tp/make_fc', { data: JSON.stringify(data),set_cover:this.cover_status }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.imageUrl = res.data.url
                    this.item_info.id = res.data.id
                }

            })
        },
        add_text() {
            this.item_info.make_item.text_list.push(this.newitem)
        },
        get_col() {
            this.$ajax.post('qhy/tp/col_fc', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.col_list = res.data.data.data
                }

            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.token = {
            Authorization:window.localStorage.getItem('token')
        }
        if (this.item_info.make_item.text_list.length < 1) {
            this.item_info.make_item.text_list.push(this.newitem)
        }
        if (this.$route.query.id) {
            this.get_info(this.$route.query.id)
        }
        this.get_col()

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
  
<style scoped></style>


// WEBPACK FOOTER //
// src/components/User/Tp/create.vue


// WEBPACK FOOTER //
// src/components/User/Tp/create.vue